import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-vehicle-status-graph',
    templateUrl: './vehicle-status-graph.component.html',
    styleUrls: ['./vehicle-status-graph.component.scss'],
    standalone: false
})
export class VehicleStatusGraphComponent implements OnInit {
  dataPie = [
    { name: 'On the Road', value: 42 },
    { name: 'Available', value: 15 },
    { name: 'In Workshop', value: 8 },
    { name: 'VOR', value: 5 },
  ];

  view: any[] = [];
  gradient: boolean = false;
  showLegend: boolean = true;
  showLabels: boolean = true;
  doughnut: boolean = true;

  colorScheme = {
    domain: ['#5AA454', '#7aa3e5', '#f99420', '#e51c23']
  };

  constructor() { }

  ngOnInit(): void {
  }

}
